var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmploymentOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 30.25,
    viewBox: "0 0 34 30.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 34,
    height: 30.25,
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#ff8302",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M92.834,28l-2.344,1.406s-4.871-.154-6.48,0a19.4,19.4,0,0,0-4.246,1.577,1.868,1.868,0,0,0-.926.959l-1.822,4.255a2.184,2.184,0,0,0,.694,1.4,2.515,2.515,0,0,0,2.8,0,21.373,21.373,0,0,0,2.477-3.5h4.219",
    transform: "translate(-67.991 -24.719)",
    fill: "none",
    stroke: "#ff8302",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M216.688,13.844A14.275,14.275,0,0,0,212,6.813L216.688,4",
    transform: "translate(-187.156 -3.531)",
    fill: "none",
    stroke: "#ff8302",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M232,114.813a13.752,13.752,0,0,0,.739-1.9l1.6-.912",
    transform: "translate(-204.813 -98.875)",
    fill: "none",
    stroke: "#ff8302",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M161.406,112l5.65,5.011a1.7,1.7,0,1,1-2.271,2.539L160,115.75",
    transform: "translate(-141.25 -98.875)",
    fill: "none",
    stroke: "#ff8302",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M158.436,178.344a1.712,1.712,0,0,1-2.667.5L152,176",
    transform: "translate(-134.188 -155.375)",
    fill: "none",
    stroke: "#ff8302",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M150.819,204.938a1.718,1.718,0,0,1-1.975-.221L148,204",
    transform: "translate(-130.656 -180.094)",
    fill: "none",
    stroke: "#ff8302",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M4,4,9.625,8.219a12.2,12.2,0,0,1,4.688-.469",
    transform: "translate(-3.531 -3.531)",
    fill: "none",
    stroke: "#ff8302",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M8.688,60S7.258,64.856,4,66.563a11.057,11.057,0,0,1,1.406,1.406",
    transform: "translate(-3.531 -52.969)",
    fill: "none",
    stroke: "#ff8302",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M25.429,134.853a1.386,1.386,0,0,1,.189.287,1.443,1.443,0,0,1-.361,1.741l-1.69,1.264a1.453,1.453,0,0,1-2.037-.173l-.238-.291a1.452,1.452,0,0,1,.173-2.037l1.689-1.264a1.439,1.439,0,0,1,2.027.175Z",
    transform: "translate(-18.498 -118.335)",
    fill: "none",
    stroke: "#ff8302",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M48.146,143.428a1.467,1.467,0,0,1,1.085.52l.255.3a1.476,1.476,0,0,1-.179,2.072l-2.735,2.171a1.467,1.467,0,0,1-2.064-.177l-.254-.3a1.611,1.611,0,0,1-.12-1.794",
    transform: "translate(-38.771 -126.62)",
    fill: "none",
    stroke: "#ff8302",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M72.42,159.8a1.5,1.5,0,0,1,.428.347l.258.31a1.49,1.49,0,0,1-.178,2.1l-3.06,2.509a1.487,1.487,0,0,1-2.093-.181l-.259-.31a1.5,1.5,0,0,1,.179-2.105",
    transform: "translate(-59.296 -141.074)",
    fill: "none",
    stroke: "#ff8302",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M100.227,192.294a1.414,1.414,0,0,1-.172,1.988l-1.182.928a1.406,1.406,0,0,1-1.988-.18l-.246-.287a1.426,1.426,0,0,1,.186-2",
    transform: "translate(-85.025 -169.76)",
    fill: "none",
    stroke: "#ff8302",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmploymentOrange);
export default __webpack_public_path__ + "static/media/employment-orange.5611e6983b6caa8e4637ea69bad3f410.svg";
export { ForwardRef as ReactComponent };